import { FC, useCallback } from 'react'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { GoogleMap, LoadScript } from '@react-google-maps/api'
import { CemeteryMarkerClusterer } from './CemeteryMarkerClusterer'
import { useListMapItems } from './dependencies'
import ContentLoader from 'react-content-loader'
import { palette } from '@lifedot/styles/palette'

const styles = {
  caption: css({
    marginBottom: '8px !important'
  }),
  titleLoader: css({
    height: '60vh',
    maxHeight: 600,
    width: '100%'
  }),
  title: css({
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    width: '100%',
    maxHeight: 600,
    height: '60vh'
  })
}

const containerStyle = {
  width: '100%',
  height: '60vh',
  maxHeight: 600
}

export type MapProps = Record<string, never> | { ids: number[] }

export const Map: FC<MapProps> = ({ ids }) => {
  const groupedItem = useListMapItems(ids)

  const onLoad = useCallback(
    (map: google.maps.Map) => {
      const listBounds = new google.maps.LatLngBounds()
      groupedItem.forEach(([, value]) => {
        const [item] = value
        if (!item) return
        const {
          location: { lat, lng }
        } = item
        listBounds.extend(new google.maps.LatLng(lat, lng))
      })
      map.fitBounds(listBounds)
    },
    [groupedItem]
  )

  if (groupedItem.length < 1) return <MapDummy />

  return (
    <>
      <p css={[typography.textS, styles.caption]}>
        地図上のアイコンを選択するとより詳細な霊園・墓地情報を閲覧できます。
      </p>
      <div style={{ height: '60vh', maxHeight: '600px', width: '100%' }}>
        <LoadScript
          googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY ?? ''}
        >
          <GoogleMap mapContainerStyle={containerStyle} onLoad={onLoad}>
            <CemeteryMarkerClusterer ids={ids} />
          </GoogleMap>
        </LoadScript>
      </div>
    </>
  )
}

const MapDummy = () => {
  return (
    <ContentLoader css={styles.titleLoader} backgroundColor={palette.gray2}>
      <rect css={styles.title} />
    </ContentLoader>
  )
}
